import React from 'react';
import PropTypes from 'prop-types';

function Button(props) {
    const {
        onClick, className, content, children, priceInfo, currency,
    } = props;

    return (
        <div
            className={`kbe-card-button-wrapper ${className}`}
            data-offer-path-nav={`${priceInfo}, ${currency}`}
        >
            <button className="kbe-card-button" type="button" onClick={onClick}>
                {content || children}
            </button>
        </div>
    );
}

Button.defaultProps = {
    className : '',
    content   : '',
    children  : '',
    priceInfo : 0,
    currency  : '',
};

Button.propTypes = {
    onClick   : PropTypes.func.isRequired,
    className : PropTypes.string,
    content   : PropTypes.oneOfType([ PropTypes.node, PropTypes.string ]),
    children  : PropTypes.oneOfType([ PropTypes.node, PropTypes.string ]),
    priceInfo : PropTypes.number,
    currency  : PropTypes.string,
};

export default Button;

// i18nLabel[bf.bookNow]
// i18nLabel[bf.logIn]
// i18nLabel[bf.roomDetails]
// i18nLabel[bf.upgradeTier]
